export default "__VITE_PUBLIC_ASSET__29be107a__"